import { render, staticRenderFns } from "./ContactRelatedItems.vue?vue&type=template&id=557ccd8c&lang=pug"
import script from "./ContactRelatedItems.vue?vue&type=script&lang=js"
export * from "./ContactRelatedItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports